(function(){
  if (window.__bwxSg) return; window.__bwxSg = true;
  var last = null;
  function norm(s){ s = String(s||'').trim().toUpperCase().replace(/\s+/g,' ');
    var m = {'XXL':'2XL','XXXL':'3XL','XXXXL':'4XL','XXXXXL':'5XL','XXS':'2XS','XXXS':'3XS','XXXXS':'4XS'}; return m[s] || s; }
  function selectedSize(){
    var i = document.querySelector('[data-variant-type="size"] input:checked');
    if (i) return i.value;
    var sel = document.querySelector('select[name="options[Size]"]');
    return sel ? sel.value : '';
  }
  function highlight(root){
    root.querySelectorAll('tr.is-hl').forEach(function(r){ r.classList.remove('is-hl'); });
    var v = selectedSize(); if (!v) return;
    var ftw = root.getAttribute('data-ftw') === 'true';
    var g = root.getAttribute('data-gender');
    root.querySelectorAll('.bwx-sg__table:not([hidden])').forEach(function(tb){
      var heads = Array.prototype.map.call(tb.querySelectorAll('thead th'), function(th){ return (th.getAttribute('data-h')||'').toUpperCase(); });
      var col = 0;
      if (ftw) {
        var want = g === 'women' ? 'US (WOMEN)' : (g === 'kids' ? 'US KIDS' : 'US (MEN)');
        col = heads.indexOf(want); if (col < 0) col = heads.indexOf('US'); if (col < 0) col = heads.indexOf('US KIDS'); if (col < 0) col = heads.indexOf('US (MEN)');
        if (col < 0) return;
      }
      tb.querySelectorAll('tbody tr').forEach(function(tr){
        var c = tr.children[col]; if (!c) return;
        var a = norm(c.getAttribute('data-raw') || c.textContent), b = norm(v);
        if (a === b || a.replace(/[A-Z]$/,'') === b) tr.classList.add('is-hl');
      });
    });
  }
  function unit(root, u){
    root.querySelectorAll('[data-bwx-sg-unit]').forEach(function(b){ var on = b.getAttribute('data-bwx-sg-unit') === u; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    root.querySelectorAll('.bwx-sg__table').forEach(function(tb){
      var cols = []; tb.querySelectorAll('thead th').forEach(function(th, i){ if (th.hasAttribute('data-cm')) cols.push(i); });
      tb.querySelectorAll('tbody tr').forEach(function(tr){
        cols.forEach(function(i){
          var c = tr.children[i]; if (!c) return;
          if (!c.hasAttribute('data-raw')) c.setAttribute('data-raw', c.textContent);
          var raw = c.getAttribute('data-raw');
          c.textContent = u === 'cm' ? raw : raw.replace(/\d+(?:[.,]\d+)?/g, function(n){ return (Math.round(parseFloat(n.replace(',', '.')) / 2.54 * 10) / 10).toString(); });
        });
      });
      tb.querySelectorAll('thead th[data-cm]').forEach(function(th){
        if (!th.hasAttribute('data-label')) th.setAttribute('data-label', th.textContent);
        th.textContent = u === 'cm' ? th.getAttribute('data-label') : th.getAttribute('data-label').replace(/\(cm\)/i, '(inch)').replace(/^cm$/i, 'inch');
      });
    });
  }
  function open(root){
    last = document.activeElement;
    if (root.parentNode !== document.body) document.body.appendChild(root);
    root.hidden = false; document.documentElement.classList.add('bwx-sg-lock');
    requestAnimationFrame(function(){ root.classList.add('is-open'); });
    highlight(root);
    var x = root.querySelector('.bwx-sg__x'); if (x) x.focus();
  }
  function close(root){
    root.classList.remove('is-open'); document.documentElement.classList.remove('bwx-sg-lock');
    setTimeout(function(){ root.hidden = true; }, 250);
    if (last && last.focus) last.focus();
  }
  document.addEventListener('click', function(e){
    var o = e.target.closest('[data-bwx-sg-open]');
    if (o) { e.preventDefault(); var r = document.getElementById(o.getAttribute('data-bwx-sg-open')); if (r) open(r); return; }
    var root = e.target.closest('[data-bwx-sg]'); if (!root) return;
    if (e.target.closest('[data-bwx-sg-close]')) { close(root); return; }
    var t = e.target.closest('[data-bwx-sg-tab]');
    if (t) {
      var g = t.getAttribute('data-bwx-sg-tab');
      root.querySelectorAll('[data-bwx-sg-tab]').forEach(function(b){ var on = b === t; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
      root.querySelectorAll('.bwx-sg__table').forEach(function(tb){ tb.hidden = tb.getAttribute('data-g') !== g; });
      highlight(root); return;
    }
    var u = e.target.closest('[data-bwx-sg-unit]');
    if (u) { unit(root, u.getAttribute('data-bwx-sg-unit')); }
  });
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Escape') return;
    var r = document.querySelector('[data-bwx-sg].is-open'); if (r) close(r);
  });
})();
